export default __webpack_public_path__ + "static/media/start-record.f8eed9ec.mp3";